import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.071 39.606c2.212-1.75 5.129-4.431 8.742-8.041 3.889-3.886 6.48-6.939 7.759-9.126.404-.692.618-1.48.618-2.281v-8.617c0-1.333-.098-1.839-.377-2.36a2.384 2.384 0 0 0-.997-.996c-.521-.279-1.027-.376-2.362-.376h-8.65c-.821 0-1.626.222-2.329.644-2.068 1.24-5.066 3.812-8.96 7.703-3.688 3.685-6.396 6.618-8.118 8.792a2.711 2.711 0 0 0-.075 3.27c1.242 1.723 3.028 3.751 5.356 6.076 2.335 2.334 4.377 4.13 6.12 5.385.985.71 2.321.68 3.273-.073Zm1.123 1.418a4.528 4.528 0 0 1-5.454.122c-1.832-1.32-3.944-3.176-6.342-5.573-2.391-2.388-4.239-4.486-5.545-6.299a4.518 4.518 0 0 1 .125-5.449c1.774-2.238 4.524-5.218 8.257-8.948 3.991-3.988 7.083-6.64 9.309-7.975A6.34 6.34 0 0 1 27.804 6h8.65c1.608 0 2.396.152 3.216.59a4.2 4.2 0 0 1 1.74 1.738c.438.82.59 1.607.59 3.213v8.617a6.326 6.326 0 0 1-.865 3.194c-1.376 2.351-4.052 5.505-8.042 9.492-3.659 3.655-6.622 6.38-8.899 8.18ZM34.76 16.852a3.62 3.62 0 0 1-3.62-3.617 3.619 3.619 0 0 1 3.62-3.618c2 0 3.62 1.62 3.62 3.617a3.619 3.619 0 0 1-3.62 3.618Zm0-1.809a1.81 1.81 0 1 0 .002-3.619 1.81 1.81 0 0 0-.002 3.62Z",
    fill: "currentColor"
  }));
};

var SvgTags = styled(SvgComponent).withConfig({
  displayName: "Tags__SvgTags",
  componentId: "sc-d5iche-0"
})(["", " ", ""], size, color);
export default SvgTags;